import { Badge } from '@pocketlaw/tetris';
import { Falcon } from '@pocketlaw/tetris/macro';
import { useDocumentAttachments } from 'shared/domains/documents/hooks/useDocumentAttachments';
import { ListButton } from '../ListButton';
export function AttachmentsButton() {
    const { count, loading } = useDocumentAttachments();
    const showBadge = !loading && count > 0;
    return (<ListButton settingsKey="attachments" icon={<Falcon icon="paperclip"/>} endElement={showBadge && <Badge size="small" appearance="secondary" value={count}/>}/>);
}
